import type { AdminPrincipalPayload, ApiResponse } from '@wanjianshi/shared-contracts';
import { adminApi } from '@/services/api/client';

export async function updateMyAvatar(file: File): Promise<AdminPrincipalPayload> {
  const body = new FormData();
  body.append('file', file);
  const response = await adminApi.post<ApiResponse<AdminPrincipalPayload>>(
    '/admin/me/avatar',
    body,
  );
  return response.data;
}

export async function changeMyPassword(payload: {
  current_password: string;
  new_password: string;
}): Promise<void> {
  await adminApi.post('/admin/me/password', payload);
}
